/**
 * 資料來源頁面模組
 */

//-----------------------------------------------------------------------
// 載入模組
import * as React from 'react';
import get from 'lodash/get';
import { useRecordContext, usePermissions, Labeled } from 'react-admin';
import { List, Show, Create, Edit, SimpleShowLayout, Datagrid, SimpleForm } from 'react-admin';
import { TextField, ShowButton, UrlField, TextInput, SelectInput } from 'react-admin';
import { ListEditButton, SaveOnlyToolbar } from '../lib/components';

//-----------------------------------------------------------------------
// defines
import { COMMON_STATUS } from '../common/defines';
import { NamePairInfo } from '../common/interfaces';
import { MemberAuthInfo } from '../providers/authProvider';

//-----------------------------------------------------------------------
/** 來源狀態顯示欄位元件。 */

const sourceStatusMap = new Map<string, string>();
const sourceStatusList : NamePairInfo<string>[] =
[
	{ id: COMMON_STATUS.Enable,		name: "啟用"},
	{ id: COMMON_STATUS.Disable,	name: "停用"}
];

for(let status of sourceStatusList)
	sourceStatusMap.set(status.id, status.name);

export const SourceStatusField = (props: any) =>
{
	const { source } = props;
	const record = useRecordContext(props);

	return (<span className="MuiTypography-body2 MuiTypography-root">{sourceStatusMap.get(get(record, source))}</span>);
}

SourceStatusField.defaultProps =
{
	label: '狀態',
	addLabel: true,
};

//-----------------------------------------------------------------------
/** 來源列表頁面。 */
export const SourceList = (props: any) =>
{
	let { permissions } = usePermissions();
	let	authInfo = permissions as MemberAuthInfo;

	return <List {...props} title='資料來源'>
		<Datagrid bulkActionButtons={false}>
			<TextField source='id' />
			<TextField source='name' label='名稱' />
			<UrlField source='url' label='網址' target='_blank' sortable={false} />
			<SourceStatusField source='status' />
			<ListEditButton edit={authInfo.sourceEdit} />
			<ShowButton />
		</Datagrid>
	</List>;
};

/** 來源資訊頁面。 */
export const SourceShow = (props: any) => (
	<Show {...props}>
		<SimpleShowLayout>
			<TextField source='id' />
			<TextField source='name' label='名稱' />
			<UrlField source='url' label='網址' target='_blank' />
			<SourceStatusField source='status' />
		</SimpleShowLayout>
	</Show>
);

/** 來源編輯頁面。 */
export const SourceEdit = (props: any) => (
	<Edit {...props}>
		<SimpleForm toolbar={<SaveOnlyToolbar/>}>
			<Labeled label="ID"><TextField source='id' /></Labeled>
			<TextInput source='name' label="名稱" />
			<TextInput source='url' type='url' label="網址" />
			<SelectInput source='status' choices={sourceStatusList} label="狀態" />
		</SimpleForm>
	</Edit>
);

/** 來源建立頁面。 */
export const SourceCreate = (props: any) => (
	<Create {...props}>
		<SimpleForm>
			<TextInput source='name' label="名稱" />
			<TextInput source='url' type='url' label="網址" />
			<SelectInput source='status' choices={sourceStatusList} label="狀態" />
		</SimpleForm>
	</Create>
);
